<template>
    <fieldset>
        <h3 class="form-heading">Email Account Details</h3>
        <div class="form-group">
            <label class="control-label">Company</label>
            <company name="EmailAccount" v-model="model.company"></company>
        </div>
        <div class="form-group">
            <label class="control-label">Server</label>
            <input readonly type="text" :value="server" class="form-control" />
        </div>
        <div class="row">
            <div class="col-lg-12">
                <a v-if="model.server_id != '0'" :href="href('/cpanel-login')" class="btn btn-primary" target="_blank">{{ trans('cpanel') }}</a>
                <a v-if="model.server_type == 'Office 365'" href="https://partner.microsoft.com/en-us/pcv/dashboard/overview" class="btn btn-primary" target="_blank">{{ trans('dashboard') }}</a>
                <button class="pull-right btn btn-success btn-sml" @click.prevent="store"><i class="icon icon-save"></i> Save</button>
            </div>
        </div>

        <br>
        <div v-if="model.server_id != '0'">
        <h3 class="form-heading">Danger Zone</h3>
        <div class="row">
            <div class="col-lg-12">
            <button @click="suspend" class="btn btn-primary" :disabled="disableBtns">
                <span v-if="model.suspended == null">Suspend</span>
                <span v-if="model.suspended != null">UnSuspend</span>
                Account
            </button>
            <button @click="terminate" class="btn btn-primary" :disabled="disableBtns">Terminate Account</button>
        </div>
        </div>
    </div>
    </fieldset>
</template>

<script>
    export default {
        props: {
            name: { default: '' },
        },
        data: function() {
            return {
                disableBtns: false,
                model: {
                    public_id: 0,
                    server: '',
                    server_id: '',
                    server_type: '',
                    suspended: '',
                    company: {}
                }
            }
        },
        created() {
            this.$eventHub.$on('saving' + this.name, this.saving);
            this.$eventHub.$on('emailaccountSubmit', this.submit);
            this.$eventHub.$on('setEmailAccount', this.setEmailAccount);
        },
        computed: {
            server() {
                return (this.model.server_id != '0') ? this.model.server : this.model.server_type;
            }
        },
        methods: {
            store(){
                this.$store('/api/email/account/update', {
                    name: this.name,
                    public_id: this.model.public_id,
                    company_id: this.model.company.id
                });
            },
            suspend() {
                this.model.suspended = (this.model.suspended === null) ? 'suspended' : null;
                this.$store('/api/email/account/suspend', {public_id: this.model.public_id});
            },
            terminate() {
                this.$store('/api/email/account/terminate', {public_id: this.model.public_id});
            },
            setEmailAccount(data) {
                this.model = this.$setData(data, this.model);
            },
            saving(boo) {
                this.disableBtns = boo;
            },
            href(link) {
                return '/email/account/' + this.model.public_id + link
            },
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
            this.$eventHub.$off('saving' + this.name, this.saving);
            this.$eventHub.$off('emailaccountSubmit', this.store);
            this.$eventHub.$off('setEmailAccount', this.setEmailAccount);
        },
        components: {
            'company': require('../../components/autocomplete/company.vue').default
        }
    }
</script>
